import { useContext } from 'react';
import { useSelector } from 'react-redux';

import { StoryContext } from '../../pages/story';
import useEntity from './useEntity';

const useStoryMembers = () => {
  const storyId = useContext(StoryContext);
  const story = useEntity({ id: storyId, type: 'stories' });
  const storyOwner = useEntity(story.member);

  const allMembers = useSelector(state => state.members);
  const membersWithoutOwner = Object.values(allMembers).filter(
    member => member.id !== story.member.id
  );

  let membersWithAvatar = [];
  let membersWithoutAvatar = [];

  Object.values(membersWithoutOwner).forEach(member => {
    if (!member['avatar-url']) {
      membersWithoutAvatar = [...membersWithoutAvatar, member];
    } else {
      membersWithAvatar = [...membersWithAvatar, member];
    }
  });

  const membersWithAvatarFirst = [...membersWithAvatar, ...membersWithoutAvatar, storyOwner];

  return membersWithAvatarFirst;
};

export default useStoryMembers;
